import { TimeAgo } from "../hooks/useTimeAgo";
import { PondooJobStatus } from "../types/ganttChart";
import labels from "./labels";
import { getStatusLabel } from "./statusBarUtils";
export type PondooStatusBarObject = {
  title: string;
  status: PondooJobStatus;
  buttonTitle?: string;
};

export const missingStatus: PondooStatusBarObject = {
  title: labels.pondooMissing,
  status: "MISSING",
};

export const missingWithStuckJobStatus: PondooStatusBarObject = {
  title: labels.pondooMissing,
  status: "MISSING",
  buttonTitle: labels.tryAgain,
};

export const runningStatus: PondooStatusBarObject = {
  title: labels.pondooRunning,
  status: "Running",
};

export const failedStatus: PondooStatusBarObject = {
  title: labels.pondooStatusError,
  buttonTitle: labels.tryAgain,
  status: "Failed",
};

export const abortedStatus: PondooStatusBarObject = {
  title: labels.pondooStatusAborted,
  buttonTitle: labels.tryAgain,
  status: "Aborted",
};

export const completedStatus = (timeAgo?: TimeAgo): PondooStatusBarObject => ({
  title: getStatusLabel(timeAgo),
  status: "Completed",
  buttonTitle: labels.update,
});

export const outdatedStatus: PondooStatusBarObject = {
  title: labels.pondooNotUpdated,
  status: "OUTDATED",
  buttonTitle: labels.update,
};
